import styled, { keyframes } from 'styled-components'

const marquee = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(var(--marquee-shift, 0)); }
`

export const LabelStyle = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: 0 0;
  box-sizing: border-box;
  overflow: hidden;
  padding: 2px 8px;
  border-radius: 6px;
  background-color: #FFFFFF;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  pointer-events: none;

  .floor-plan-label-track {
    display: flex;
    width: max-content;
    white-space: nowrap;
    font-family: NunitoSansRegular, 'Nunito Sans', sans-serif;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: #1A1A1A;
  }

  .floor-plan-label-track.scrolling {
    animation: ${marquee} var(--marquee-duration) linear infinite;
    will-change: transform;
  }
`
